import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
 
} from "../../service/casino";
import { useParams } from "react-router-dom";
import {
  getOddsByRunner,
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions";
import toast from "react-hot-toast";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function BaccaratGeneric() {
  const { id: GAME_ID } = useParams();
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const generic = GAME_ID == "UNI_1_CARD_20_20";
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };

  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
 
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt
      ? new Date(odds.roundWinnerUpdatedAt).getTime()
      : 0;

    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    // Add interval for time condition check
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);

  return (
    <app-baccarat _nghost-ng-c2331422850="">
      <div
        style={{ overflowY: "scroll", height: "min-content" }}
        _ngcontent-ng-c2331422850=""
      >
        <app-video-player _ngcontent-ng-c2331422850="" _nghost-ng-c595356512="">
          <div _ngcontent-ng-c595356512="" className="videoPlayer">
            <video
              _ngcontent-ng-c595356512=""
              id="remoteVideo"
              width="100%"
              height="100%"
              autoPlay=""
              playsInline=""
              muted=""
              style={{ backgroundColor: "black", backgroundSize: "contain" }}
            />

            <div _ngcontent-ng-c595356512="" className="video-overlay">
              <div _ngcontent-ng-c595356512="">
                <div
                  _ngcontent-ng-c595356512=""
                  className="round-id text-white"
                >
                  RID:{odds?.roundId}
                </div>

                {odds?.playerCards?.map((player) => (
                  <div _ngcontent-ng-c595356512="">
                    <h3 _ngcontent-ng-c595356512="" className="text-white">
                      {player?.forPerson}
                    </h3>
                    <div _ngcontent-ng-c595356512="">
                      {player?.cards?.map((card) => (
                        <img
                          _ngcontent-ng-c595356512=""
                          src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {showWinnerOverlay && (
              <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                <div
                  _ngcontent-ng-c595356512=""
                  className="mini-result-new active"
                >
                  <span _ngcontent-ng-c595356512="">
                    {" "}
                    {odds?.roundWinner} win{" "}
                  </span>
                  {/**/}
                </div>
                <span
                  _ngcontent-ng-c595356512=""
                  style={{ position: "absolute" }}
                >
                  <canvas
                    _ngcontent-ng-c595356512=""
                    width="100vw"
                    height="100vh"
                  />
                </span>
                {/**/}
              </div>
            )}

            <div _ngcontent-ng-c595356512="" className="timer-overlay">
              <GenericCasinoTimer time={odds?.seconds} status={odds?.status} />
            </div>
          </div>

          <div
            _ngcontent-ng-c595356512=""
            id="rulesModal"
            tabIndex={-1}
            aria-labelledby="exampleModalLabelaexampleModalLabela"
            aria-hidden="true"
            className="modal fade"
          >
            <div
              _ngcontent-ng-c595356512=""
              className="modal-dialog rules-wrap"
            >
              <div
                _ngcontent-ng-c595356512=""
                role="document"
                id="rulesList___BV_modal_content_"
                tabIndex={-1}
                className="modal-content rules-content"
              >
                <header
                  _ngcontent-ng-c595356512=""
                  id="rulesList___BV_modal_header_"
                  className="rules-wrap"
                >
                  <a _ngcontent-ng-c595356512="">
                    <h3
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_title_"
                      data-bs-toggle="modal"
                      data-bs-target="#rulesModal"
                      className="modal-title"
                    >
                      Rules
                    </h3>
                  </a>
                  <button
                    _ngcontent-ng-c595356512=""
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="close"
                  >
                    ×
                  </button>
                </header>
                <div
                  _ngcontent-ng-c595356512=""
                  id="rulesList___BV_modal_body_"
                  className="modal-body"
                >
                  <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                </div>
                <div _ngcontent-ng-c595356512="">
                  <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                    <li _ngcontent-ng-c595356512="">
                      <a
                        _ngcontent-ng-c595356512=""
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="btnok"
                      >
                        OK
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </app-video-player>
        <div _ngcontent-ng-c2331422850="" className="scrollMarket">
          <div _ngcontent-ng-c2331422850="" className="baccarat">
            <div _ngcontent-ng-c2331422850="" className="baccarat-bets">
              <div
                _ngcontent-ng-c2331422850=""
                className={`player ${
                  getOddsByRunner(odds, "PLAYER", true)?.status == "SUSPEND"
                    ? "suspended"
                    : ""
                }`}
              >
                <div
                  _ngcontent-ng-c2331422850=""
                  className="baccarat-bets-name"
                >
                  <div _ngcontent-ng-c2331422850="">{"PLAYER"}</div>
                  <div _ngcontent-ng-c2331422850="">
                    {getOddsByRunner(odds, "PLAYER")}{" "}
                  </div>
                  <div _ngcontent-ng-c2331422850="" className="profitLoss">
                    {getUniversalCasinoPlExposureByRunner(exposure, "PLAYER")}
                  </div>
                  <li
                    _ngcontent-ng-c2331422850=""
                    className="chips_1_selected"
                    style={{ display: "none" }}
                  >
                    <p _ngcontent-ng-c2331422850="" />
                  </li>
                </div>
              </div>
              <div
                _ngcontent-ng-c2331422850=""
                className={`tie ${
                  getOddsByRunner(odds, "TIE", true)?.status == "SUSPEND"
                    ? "suspended"
                    : ""
                }`}
              >
                <div
                  _ngcontent-ng-c2331422850=""
                  className="baccarat-bets-name"
                >
                  <div _ngcontent-ng-c2331422850="">TIE</div>
                  <div _ngcontent-ng-c2331422850="" className="mb-0">
                    {getOddsByRunner(odds, "TIE")}
                  </div>
                  <div _ngcontent-ng-c2331422850="" className="profitLoss">
                    {getUniversalCasinoPlExposureByRunner(exposure, "TIE")}
                  </div>
                  <li
                    _ngcontent-ng-c2331422850=""
                    className="chips_1_selected"
                    style={{ display: "none" }}
                  >
                    <p _ngcontent-ng-c2331422850="" />
                  </li>
                </div>
              </div>
              <div
                _ngcontent-ng-c2331422850=""
                className={`banker ${
                  getOddsByRunner(odds, "TIE", true)?.status == "SUSPEND"
                    ? "suspended"
                    : ""
                }`}
              >
                <div
                  _ngcontent-ng-c2331422850=""
                  className="baccarat-bets-name"
                >
                  <div _ngcontent-ng-c2331422850="">
                    {generic ? "DEALER" : "BANKER"}
                  </div>
                  <div _ngcontent-ng-c2331422850="">
                    {getOddsByRunner(odds, generic ? "DEALER" : "BANKER")}
                  </div>
                  <div _ngcontent-ng-c2331422850="" className="profitLoss">
                    {getUniversalCasinoPlExposureByRunner(
                      exposure,
                      generic ? "DEALER" : "BANKER"
                    )}
                  </div>
                  <li
                    _ngcontent-ng-c2331422850=""
                    className="chips_1_selected"
                    style={{ display: "none" }}
                  >
                    <p _ngcontent-ng-c2331422850="" />
                  </li>
                </div>
              </div>
            </div>
          </div>

          <div _ngcontent-ng-c2331422850="" className="pairmobile show-xs mt-3">
            <div
              _ngcontent-ng-c2331422850=""
              className="baccarat"
              style={{ marginTop: 1 }}
            >
              <div
                _ngcontent-ng-c2331422850=""
                className="baccarat-bets"
                style={{ margin: "0 0 15px 0" }}
              >
                <div
                  _ngcontent-ng-c2331422850=""
                  className={`player-pair ${
                    getOddsByRunner(odds, "TIE", true)?.status == "SUSPEND"
                      ? "suspended"
                      : ""
                  } ${generic ? "playerWidthCard20 " : ""}`}
                >
                  <div
                    _ngcontent-ng-c2331422850=""
                    className="baccarat-bets-name"
                  >
                    <div _ngcontent-ng-c2331422850="">
                      {generic ? "PAIR" : "PLAYER PAIR"}
                    </div>
                    <div _ngcontent-ng-c2331422850="" className="mb-0">
                      {getOddsByRunner(odds, generic ? "PAIR" : "PLAYER PAIR")}
                    </div>
                    <div _ngcontent-ng-c2331422850="" className="profitLoss">
                      {getUniversalCasinoPlExposureByRunner(
                        exposure,
                        generic ? "PAIR" : "PLAYER PAIR"
                      )}
                    </div>
                    <li
                      _ngcontent-ng-c2331422850=""
                      className="chips_1_selected"
                      style={{ display: "none" }}
                    >
                      <p _ngcontent-ng-c2331422850="" />
                    </li>
                  </div>
                </div>
                {!generic && (
                  <div
                    _ngcontent-ng-c2331422850=""
                    className={`banker-pair ${
                      getOddsByRunner(odds, "TIE", true)?.status == "SUSPEND"
                        ? "suspended"
                        : ""
                    }`}
                  >
                    <div
                      _ngcontent-ng-c2331422850=""
                      className="baccarat-bets-name"
                    >
                      <div _ngcontent-ng-c2331422850="">BANKER PAIR</div>
                      <div _ngcontent-ng-c2331422850="" className="mb-0">
                        {getOddsByRunner(odds, "BANKER PAIR")}
                      </div>
                      <div _ngcontent-ng-c2331422850="" className="profitLoss">
                        {getUniversalCasinoPlExposureByRunner(
                          exposure,
                          "BANKER PAIR"
                        )}
                      </div>
                      <li
                        _ngcontent-ng-c2331422850=""
                        className="chips_1_selected"
                        style={{ display: "none" }}
                      >
                        <p _ngcontent-ng-c2331422850="" />
                      </li>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <section
            _ngcontent-ng-c2331422850=""
            id="functionZone"
            className="function_zone"
          >
            <ul _ngcontent-ng-c2331422850="" id="chips" className="chips">
              {[
                { img: "chips1", amount: 100, label: "100" },
                { img: "chips1", amount: 500, label: "500" },
                { img: "chips1k", amount: 1000, label: "1k" },
                { img: "chips5", amount: 5000, label: "5k" },
                { img: "chips10", amount: 10000, label: "10k" },
                { img: "chips20", amount: 25000, label: "25k" },
                { img: "chips1k", amount: 50000, label: "50k" },
                { img: "chips1k", amount: 100000, label: "1L" },
              ].map((item) => (
                <li
                  _ngcontent-ng-c1910803830=""
                  className={`chips_1 ${
                    placeBetPayload?.amount === item.amount ? "now" : ""
                  }`}
                >
                  <img
                    _ngcontent-ng-c1910803830=""
                    src={`https://casino.queenexch.com/assets/chips/${item?.img}.svg`}
                  />

                  <p _ngcontent-ng-c1910803830="">{item.label} </p>
                  <span _ngcontent-ng-c1910803830="" className="ring">
                    ring
                  </span>
                </li>
              ))}
            </ul>
          </section>
          <GetUniversalLastTenResult lastResult={lastResult} />
        </div>
      </div>
    </app-baccarat>
  );
}
